import { Link } from 'gatsby';
import React from 'react';
import { graphql, useStaticQuery } from "gatsby";
import { Helmet } from 'react-helmet';
import Main from "../Layout/Main";
import Section from "../Layout/Section/Section";
import InnerContainer from "../Layout/InnerContainer/InnerContainer";
import PreviewCompatibleImage from '../Utils/PreviewCompatibleImage';

import './admin-page.scss';

const Admin = () => {
  const { allMarkdownRemark } = useStaticQuery(graphql`
    query adminQuery {
      allMarkdownRemark(filter: {frontmatter: {type: {eq: "gated"}}}) {
        nodes {
          frontmatter {
            partnerName
            path
            adminPanelLogo{
              childImageSharp {
                fluid(maxWidth: 2048, quality: 80) {
                  ...GatsbyImageSharpFluid
                }
              }
              extension
              publicURL
            }
          }
        }
      }
    }
  `)

  function renderPartners() {
    // console.log("markdownRemark...", allMarkdownRemark.nodes);
    let partnersData = [];
    allMarkdownRemark.nodes.forEach(node => {
      let partner = new Object();
      partner.name = node.frontmatter.partnerName;
      partner.path = node.frontmatter.path;
      partner.logo = node.frontmatter.adminPanelLogo;
      partnersData.push(partner);
    })
    // console.log("partnersData", partnersData);

    return <ul className="link-grid">{renderPartnerLinks(partnersData)}</ul>
  }

  function renderPartnerLinks(partnersData) {
    let parterLinksHTML = [];
    partnersData.forEach(
      function(partner) {
        parterLinksHTML.push(<Link className="link-grid__link" to={partner.path}>
          <li className="link-grid__list-item">
            <PreviewCompatibleImage customClass="link-grid__partner-logo" imageInfo={partner.logo} alt={partner.name} />
            <p className="link-grid__partner-name">{partner.name}</p>
          </li>
        </Link>)
      }
    )

    return parterLinksHTML;
  }

  return (
    <Main>
      <Helmet>
        <body className="page admin-page" />
      </Helmet>
      <h3>Partner Dashboard</h3>
      {renderPartners()}
    </Main>
  )
}

export default Admin;
